<template>
  <b-dropdown
    v-if="nomeUsuario"
    class="sf-plan-dd"
    variant="link"
    toggle-class="sf-plan-card"
    menu-class="sf-nav-menu sf-plan-menu"
    no-caret
    dropup
    block
  >
    <template #button-content>
      <span class="sf-plan-badge">SF</span>
      <span class="sf-plan-info">
        <span class="sf-plan-name">{{ nomeUsuario }}</span>
        <span class="sf-plan-status">
          <span
            class="sf-plan-dot"
            :class="{ off: !ativa }"
          />
          <span class="sf-plan-status-text">{{ planoNome }}</span>
        </span>
      </span>
      <feather-icon
        icon="ChevronRightIcon"
        size="16"
        class="sf-plan-chevron"
      />
    </template>

    <b-dropdown-item :to="{ name: 'conta-configuracao' }">
      <feather-icon
        icon="SettingsIcon"
        size="15"
        class="sf-menu-ic"
      />
      <span class="sf-menu-label">{{ $t('Ajustes') }}</span>
    </b-dropdown-item>
    <b-dropdown-item :to="{ name: 'conta-assinatura' }">
      <feather-icon
        icon="CreditCardIcon"
        size="15"
        class="sf-menu-ic"
      />
      <span class="sf-menu-label">{{ $t('Assinatura') }}</span>
    </b-dropdown-item>
    <b-dropdown-item :to="{ name: 'suporte' }">
      <feather-icon
        icon="HeadphonesIcon"
        size="15"
        class="sf-menu-ic"
      />
      <span class="sf-menu-label">{{ $t('Suporte') }}</span>
    </b-dropdown-item>
    <b-dropdown-divider />
    <b-dropdown-item @click="logout">
      <feather-icon
        icon="LogOutIcon"
        size="15"
        class="sf-menu-ic"
      />
      <span class="sf-menu-label">{{ $t('Sair') }}</span>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
// Card de plano no rodapé da sidebar (redesign Soulf). Mostra plano+status
// (identidade da conta fica só aqui, não no navbar) e abre um menu com as
// opções de conta — inclusive Sair (logout migrado do UserDropdown).
import { BDropdown, BDropdownItem, BDropdownDivider } from 'bootstrap-vue'
import { initialAbility } from '@/libs/acl/config'
import useJwt from '@/auth/jwt/useJwt'

export default {
  name: 'PlanoSidebarCard',
  components: { BDropdown, BDropdownItem, BDropdownDivider },

  data() {
    return {
      planoNome: '',
      statusTexto: '',
      ativa: false,
    }
  },

  computed: {
    nomeUsuario() {
      const ud = JSON.parse(localStorage.getItem('userData') || '{}')
      return ud.displayName || ud.nome || this.$t('Assinatura')
    },
  },

  created() {
    this.$http.get('assinatura')
      .then(response => {
        const assinatura = (response.data || [])[0]
        if (!assinatura) return
        this.planoNome = (assinatura.variacao && assinatura.variacao.nome)
          || (assinatura.plano && assinatura.plano.nome)
          || this.$t('Assinatura')
        this.statusTexto = assinatura.status || ''
        this.ativa = assinatura.status === 'Ativo'
      })
      .catch(() => { /* sem assinatura: card não é exibido */ })
  },

  methods: {
    logout() {
      localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
      localStorage.removeItem('userData')
      localStorage.removeItem('cb-products')
      localStorage.removeItem('cb-context')
      localStorage.removeItem(useJwt.jwtConfig.storageImpersonateKeyName)
      this.$ability.update(initialAbility)
      this.$router.push({ name: 'auth-login' })
    },
  },
}
</script>
